// extracted by mini-css-extract-plugin
export default {"numberFieldWithFlexibility":"numberFieldWithFlexibility__MzRkO","checkbox":"checkbox__MDcyO"};